export default __webpack_public_path__ + "static/manually-351962964dbd5d4f24e933372efd9b85.png";